import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Facebook from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";
import { mergeManagedContent } from "../../hooks/mergeManagedContent";
import { colors, radii } from "../../theme/designTokens";

const btnSx = {
  justifyContent: "flex-start",
  borderRadius: radii.md,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13.5,
  py: 1.1,
  mb: 1.25,
  bgcolor: colors.primaryLight,
  color: colors.primaryDark,
  boxShadow: "none",
  "&:hover": { bgcolor: colors.primaryLight, boxShadow: "none", opacity: 0.85 },
};

export default function MoreCallOptions({ contactMedium }) {
  const [langId, setLangId] = useState("");
  const [contentSettings, setContentSettings] = useState([]);

  const { webSettings } = useSelector((state) => state.webSettings);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { langs } = useSelector((state) => state.misc);

  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);

  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  const phoneNumbers =
    (contentSettings.footerContactInfo &&
      contentSettings.footerContactInfo.contactNumber) ||
    [];
  const primaryPhone = phoneNumbers[0] || "";
  const waNumber = primaryPhone.replace(/[^\d]/g, "");

  return (
    <Box>
      {primaryPhone && (
        <Button
          startIcon={<CallIcon />}
          fullWidth
          sx={btnSx}
          href={`tel:${primaryPhone.replace(/\s/g, "")}`}
        >
          {contactMedium} Us On Phone
        </Button>
      )}
      {waNumber && (
        <Button
          startIcon={<WhatsAppIcon sx={{ color: "#25D366" }} />}
          fullWidth
          sx={btnSx}
          href={`https://wa.me/${waNumber}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {contactMedium} Us On WhatsApp
        </Button>
      )}
      {webSettings?.socialMediaPages?.fb && (
        <Button
          startIcon={<Facebook sx={{ color: "#1877F2" }} />}
          fullWidth
          sx={btnSx}
          href={webSettings.socialMediaPages.fb}
          target="_blank"
          rel="noopener noreferrer"
        >
          {contactMedium} Us On Facebook
        </Button>
      )}
      {webSettings?.socialMediaPages?.telegram && (
        <Button
          startIcon={<TelegramIcon sx={{ color: "#229ED9" }} />}
          fullWidth
          sx={{ ...btnSx, mb: 0 }}
          href={webSettings.socialMediaPages.telegram}
          target="_blank"
          rel="noopener noreferrer"
        >
          {contactMedium} Us On Telegram
        </Button>
      )}
    </Box>
  );
}
